// ADDED
import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { ImageViewModal } from "../../../../../common/Modal";
import { StatusBadge } from "../../../../../common/Badge";

const OffsetRequestHistory = ({ isOpen, onClose, data = [] }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewer, setViewer] = useState({ isOpen: false, data: null });

  if (!isOpen) return null;

  // Split data based on type
  const overtimeHistory = data.filter((item) => item.type === "Overtime");
  const leaveHistory = data.filter((item) => item.type === "Leave");

  // Headers and Accessors
  const otHeaders = ["Ref No.", "Date Used", "Hours", "Status", "File"];
  const otAccessors = ["referenceNumber", "date", "hours", "status", "content"];

  const leaveHeaders = ["Ref No.", "Date From", "Date To", "Days", "Status", "File"];
  const leaveAccessors = ["referenceNumber", "dateFrom", "dateTo", "days", "status", "content"];

  const customRender = (row, accessor) => {
    if (accessor === "referenceNumber") {
      return `OS-${row[accessor]?.toString().padStart(6, "0")}`;
    }

    if (["date", "dateFrom", "dateTo", "dateRequested"].includes(accessor)) {
      return row[accessor] ? new Date(row[accessor]).toLocaleDateString() : "-";
    }

    if (accessor === "status") {
      return <StatusBadge status={row[accessor]} />;
    }

    if (accessor === "content") {
      return row[accessor] ? (
        <button
          onClick={() => setViewer({ isOpen: true, data: row.content })}
          className="text-blue-500 bg-transparent border-none cursor-pointer hover:text-blue-700"
        >
          <AttachFileIcon fontSize="small" />
        </button>
      ) : "-";
    }

    return null; // Fallback to default table rendering
  };

  return (
    <>
      <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
        <div className="bg-gray-50 w-full md:w-[90%] rounded-lg shadow-xl max-h-[90vh] flex flex-col">

          {/* Header */}
          <div className="flex justify-between items-center px-6 py-3 border-b bg-white rounded-t-lg">
            <h2 className="text-xl font-semibold text-gray-500">Offset Filed History</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Body with Tabs */}
          <div className="p-6 overflow-y-auto flex-grow">
            <Tabs selectedIndex={activeTab} onSelect={(index) => { setActiveTab(index); setCurrentPage(1); }}>
              <TabList className="flex border-b mb-4 gap-4">
                <Tab className={`pb-2 px-4 cursor-pointer outline-none transition-all ${activeTab === 0 ? "border-b-2 border-blue-500 text-blue-600 font-bold" : "text-gray-400"}`}>
                  OVERTIME OFFSET
                </Tab>
                <Tab className={`pb-2 px-4 cursor-pointer outline-none transition-all ${activeTab === 1 ? "border-b-2 border-blue-500 text-blue-600 font-bold" : "text-gray-400"}`}>
                  LEAVE OFFSET
                </Tab>
              </TabList>

              <TabPanel>
                <CreateTable
                  headers={otHeaders}
                  accessors={otAccessors}
                  data={overtimeHistory}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={10}
                  totalItems={overtimeHistory.length}
                  customCellRenderer={customRender}
                />
              </TabPanel>

              <TabPanel>
                <CreateTable
                  headers={leaveHeaders}
                  accessors={leaveAccessors}
                  data={leaveHistory}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={10}
                  totalItems={leaveHistory.length}
                  customCellRenderer={customRender}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>

      {/* Image Viewer for attachments */}
      <ImageViewModal
        isOpen={viewer.isOpen}
        onClose={() => setViewer({ ...viewer, isOpen: false })}
        fileData={viewer.data}
        fileType="image/jpeg"
      />
    </>
  );
};

export default OffsetRequestHistory;